import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const faroEnv = import.meta.env.VITE_ENV;
// Expected: https://faro-collector-<region>.grafana.net/collect/<app-key>
const faroCollectorUrl = import.meta.env.VITE_FARO_COLLECTOR_URL;
const faroEnabled = faroEnv !== 'local' && Boolean(faroCollectorUrl);

if (faroEnabled) {
  try {
    initializeFaro({
      url: faroCollectorUrl,
      app: {
        name: 'grant-guardian-web',
        version: import.meta.env.VITE_APP_VERSION,
        environment: faroEnv,
      },
      // captureConsole stays off because the app logs raw axios error bodies
      // (which carry grantee data) in several places; sending those wholesale
      // to Grafana would be an unscoped data egress. Uncaught errors and
      // unhandled rejections are still captured via the default web
      // instrumentations.
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: false }),
        new TracingInstrumentation(),
      ],
      // Session id lives in sessionStorage and does not survive logout / a
      // new user on a shared device.
      sessionTracking: { persistent: false },
    });
  } catch (err) {
    // Telemetry must never block app boot.
    console.error('Faro init failed; continuing without RUM', err);
  }
}
